
import { useParams as _useParams } from "react-router"
import { NavigationParams } from "types/navigation"

export const useParams = () => _useParams<NavigationParams>();